import { render, staticRenderFns } from "./LoginGoogle.vue?vue&type=template&id=058a7fb0"
import script from "./LoginGoogle.vue?vue&type=script&lang=js"
export * from "./LoginGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports